const getFileName = (el, id) => { 
    if(el.files[0]) document.getElementById(id).innerText = el.files[0].name;
}

if (document.getElementById('mpup-1')) { 
    window.addEventListener('load', () => { 
        getFileName( document.getElementById('thumbnail-1'), 'mpup-1' )
        getFileName( document.getElementById('thumbnail-2'), 'mpup-2' )
        getFileName( document.getElementById('thumbnail-3'), 'mpup-3' )
        getFileName( document.getElementById('thumbnail-4'), 'mpup-4' )
    })
}


const showImage = (el, src) => { 
    const galleryItems = document.querySelectorAll('.image--gallery-item ')
    const targetImage = document.querySelector('#main--image img')

    galleryItems.forEach(item => item.classList.remove('active'))

    el.classList.add('active')

    targetImage.src = src
    
}